import api from '../api/api'
import settings from "../modules/settings";
import dialogs from '../modules/dialogs'

const useEmo = settings.user.getUseEmoticons();
const stylePath = () => {
    var isDarkTheme = localStorage.getItem('theme') === 'dark';
    if (isDarkTheme) {
        return '/styles/style-sceditor-dark.css'            
    } else {
        return '/styles/style-sceditor.css'
    }
}

const postEditor = {

    editorConfig: {
        format: 'bbcode',
        style: stylePath,
        width: '99%',
        height: '250px',
        toolbar: "bold,italic,underline|strike,subscript,superscript|left,center,right|size,color,plaintext|bulletlist,orderedlist|table,code,quote|link,unlink|emoticon|date,time|maximize,source",
        autoExpand: true,
        plugins: 'dragdrop,plaintext',
        emoticonsEnabled: useEmo,
        plaintext: {
            addButton: false,
            enabled: true,
            customFunction: () => {
                dialogs.alertAsync('this is the custom func running');
            },
        },
        emoticons: {
            dropdown: {
                ':2cents:': '/emoticons/2cents.gif',
                ':bow:': '/emoticons/acclaim.gif',
                ':applause:': '/emoticons/applause.gif',
                ':btt:': '/emoticons/backtotopic.gif',
                ':bg:': '/emoticons/big_grin.gif',
                ':o': '/emoticons/blush.gif',
                'o&#33;': '/emoticons/cheers.gif',
                ':coffee:': '/emoticons/coffee1.gif/',
                ':compute:': '/emoticons/compute.gif',
                ':confused:': '/emoticons/confused.gif',                        
                ':cool:': '/emoticons/cool.gif',
                ':crazy:': '/emoticons/crazy.gif',
                ':bawl:': '/emoticons/cryhard.gif',
                ':dance:': '/emoticons/dance.gif',
                ':dazed:': '/emoticons/dazed.gif',
                ':doh:': '/emoticons/doh.gif',
                ':dunno:': '/emoticons/dontknow.gif',
                ':dunce:': '/emoticons/dunce.gif',
                ':evil:': '/emoticons/evilgrin.gif',
                ':(': '/emoticons/frown.gif',
                ':fundrink:': '/emoticons/fundrink.gif',
                ':giveup:': '/emoticons/giveup.gif',
                'grin::': '/emoticons/grin.gif',
                ':halo:': '/emoticons/grinhalo.gif',
                ':beer:': '/emoticons/guiness.gif',
                ':hattip:': '/emoticons/hat_tip.gif',
                ':iconfused:': '/emoticons/iconfused.gif',
                ':kiss:': '/emoticons/kisses.gif',
                ':D': '/emoticons/laugh.gif',
                ':lightbulb:': '/emoticons/lightbulb.gif',
                ':like:': '/emoticons/like.png',
                ':mad:': '/emoticons/mad.gif',
                ':notworthy:': '/emoticons/notworthy.gif',
                ':ohyeah:': '/emoticons/ohyeah.gif',
                ':ooo:': '/emoticons/ooo.gif',
                ':pompom:': '/emoticons/pompom.gif',
                ':pullhair:': '/emoticons/pullhair.gif',
                ':read:': '/emoticons/reading.gif',
                ':lol:': '/emoticons/rotflmao.gif',
                ':sad:': '/emoticons/sad.gif',
                ':sarcasm:': '/emoticons/sarcasm.gif',
                ':shocked:': '/emoticons/shocked.gif',
                ':shrug:': '/emoticons/shrug.gif',
                ':zzzz:': '/emoticons/sleeping.gif',
                ':)': '/emoticons/smile.gif',
                ':smirk:': '/emoticons/smirk.gif',
                ':thanks:': '/emoticons/thanks.gif',
                ':thumbdn:': '/emoticons/thumbdn.gif',
                ':thumbup:': '/emoticons/thumbup.gif',
                ':p': '/emoticons/tongue.gif',
                ':uarulez:': '/emoticons/uarulez2.gif',
                ':wary:': '/emoticons/wary.gif',
                'ho&#33;': '/emoticons/wavehi.gif',
                ':welcome:': '/emoticons/welcome2UA.gif',
                ':whew:': '/emoticons/whew.gif',
                ':wine:': '/emoticons/wine.gif',
                ';)': '/emoticons/wink.gif',
                ':woohoo:': '/emoticons/woohoo.gif',
                ':yay:': '/emoticons/yayhandclap.gif',
                ':yw:': '/emoticons/yw.gif'
            }
        },
        dragdrop: {
            allowedTypes: null,
            isAllowed: function(file) {
                if (file)
                    return true;
            },
            handleFile: function(file, createPlaceholder) {
                var placeholder = createPlaceholder();
                api.postFile('/attachments/attach', file).then((response) => {

                    var att = response.data;
                    
                    var elementString = "";

                    if (att.livePreview === true) {
                        elementString = `<a target="_blank" data-ua-attachment="${att.attachmentID}" href="${att.url}"><img data-ua-attachment-preview="true" src="${att.tempUrl}" /></a>`;
                    } else {
                        elementString = `<a target="_blank" data-ua-attachment="${att.attachmentID}" href="attachments/${att.attachmentID}" data-ua-download="true">${att.fileName}</a>`;
                    }
                    placeholder.insert(elementString);

                }).catch(() => {
                    placeholder.cancel();
                });
            }
        }
    }



}

export default postEditor;